// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const petRoutes = [
  route('create', '/create', Create, meta('Adicionar novo pet', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar pet', true, 'guest')),
  route('index', '/index', Index, meta('Lista de pets', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/pets', petRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/dweller/pets/routes.js